export default function AppInput({ field, form, meta, ...props }) {
  return <input {...field} {...props} type={props?.type ?? "text"} className={`form ${props.className}`} />;
}
